import React from "react";
import "./cloud9.css";
import { useReveal } from "./hooks/useReveal";
import CoffeeScroll from "./components/CoffeeScroll";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import StitchDivider from "./components/StitchDivider";
import Marquee from "./components/Marquee";
import Story from "./components/Story";
import Concept from "./components/Concept";
import Menu from "./components/Menu";
import Gallery from "./components/Gallery";
import Reserve from "./components/Reserve";
import Footer from "./components/Footer";

function App() {
  useReveal([]);

  return (
    <div className="c9">
      <div className="grain" />
      <CoffeeScroll />
      <Nav />
      <Hero />
      <StitchDivider onInk />
      <Marquee />
      <Story />
      <StitchDivider />
      <Concept />
      <StitchDivider onInk />
      <Menu />
      <StitchDivider />
      <Gallery />
      <StitchDivider onInk />
      <Reserve />
      <Footer />
    </div>
  );
}

export default App;
